var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.startFormatted))]),_c('td',[_vm._v(_vm._s(_vm.petName))]),_c('td',[_vm._v(_vm._s(_vm.resourceName))]),_c('td',[_vm._v(_vm._s(_vm.status))])])
}
var staticRenderFns = []

export { render, staticRenderFns }